import React from 'react';
import { Grid } from '@mui/material';
import TourCardPublicSkeleton from './TourCardPublicSkeleton';

interface TourGridSkeletonProps {
    count?: number;
}

export default function TourGridSkeleton({ count = 3 }: TourGridSkeletonProps) {
    return (
        <Grid container spacing={3}>
            {Array.from({ length: count }).map((_, idx) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                    <TourCardPublicSkeleton />
                </Grid>
            ))}
        </Grid>
    );
}
